<div class="card">
    <div *ngIf="questions" class="card-body">
        <h4 class="card-title">Editar preguntas Kostick</h4>
        
        <div class="m-t-40">
                <div class="d-flex">
                
                    <div class="ml-auto">

                    </div>
                </div>
            </div>
        <table  class="table table-bordered table-hover toggle-circle " >
            <thead>
                <tr>
                    <th>#</th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Texto A</th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Texto B</th>
                    <th class="min-width footable-visible footable-last-column text-center">Editar/Eliminar</th>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let question of questions">
                    <td>{{question.index}}</td>
                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.opcA.text}}</td>
                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.opcB.text}}</td>
                    
                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" data-target="#myModal" (click)="handleEdit(question._id)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(question._id)" ><i class="fa fa-eraser" ></i></button>    
                    </td>
                </tr>
            </tbody>
     
        </table>
    </div>
</div>

<div *ngIf="kostikForm" id="myModal" data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-lg p-20">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">AllPort</h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <form [formGroup]="kostikForm" (ngSubmit)="update()">
                <div class="form-body">
                    <h3 class="card-title">Datos de la pregunta</h3>
                    <hr>
                    <div class="row p-t-20">
                        <!--/span-->
                        <div class="row" formGroupName="opcA">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Texto opción A</label>
                                    <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Serie</label>
                                    <select formControlName="value" class="form-control custom-select">
                                        <option value="n">N</option>
                                        <option value="a">A</option>
                                        <option value="p">P</option>
                                        <option value="x">X</option>
                                        <option value="b">B</option>
                                        <option value="o">O</option>
                                        <option value="z">Z</option>
                                        <option value="k">K</option>
                                        <option value="f">F</option>
                                        <option value="w">W</option>
                                        <option value="g">G</option>
                                        <option value="l">L</option>
                                        <option value="i">I</option>
                                        <option value="t">T</option>
                                        <option value="v">V</option>
                                        <option value="s">S</option>
                                        <option value="r">R</option>
                                        <option value="c">C</option>
                                        <option value="e">E</option>
                                        <option value="d">D</option>


                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="row" formGroupName="opcB">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Texto opción B</label>
                                    <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Serie</label>
                                    <select formControlName="value" class="form-control custom-select">
                                        <option value="n">N</option>
                                        <option value="a">A</option>
                                        <option value="p">P</option>
                                        <option value="x">X</option>
                                        <option value="b">B</option>
                                        <option value="o">O</option>
                                        <option value="z">Z</option>
                                        <option value="k">K</option>
                                        <option value="f">F</option>
                                        <option value="w">W</option>
                                        <option value="g">G</option>
                                        <option value="l">L</option>
                                        <option value="i">I</option>
                                        <option value="t">T</option>
                                        <option value="v">V</option>
                                        <option value="s">S</option>
                                        <option value="r">R</option>
                                        <option value="c">C</option>
                                        <option value="e">E</option>
                                        <option value="d">D</option>


                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">    
                            <div class="form-group">
                                <label class="control-label">Ìndice</label>
                                <input formControlName="index" type="number" class="form-control" placeholder="Índice">
                            </div>
                        </div>

                    
                </div>
            </div>

                <div class="form-actions">
                    <button type="submit" class="btn btn-success"> <i class="fa fa-check"></i> Guardar</button>
                </div>
            </form>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

